import { memo } from "react";
import Highlighter from "react-highlight-words";

const ParagraphHighliter = ({ title, search }) => {
  if (title == null || title === "") return null;
  if (!search) return title;

  return (
    <Highlighter
      highlightStyle={{ backgroundColor: "#ffc069" }}
      searchWords={[search]}
      autoEscape
      textToHighlight={String(title)}
    />
  );
};

export default memo(ParagraphHighliter);
